// DS: i7.17
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorBullet = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M6.5 10c-.83 0-1.5.67-1.5 1.5S5.67 13 6.5 13 8 12.33 8 11.5c0-.781-.593-1.42-1.355-1.493L6.5 10zm0 6c-.83 0-1.5.67-1.5 1.5S5.67 19 6.5 19 8 18.33 8 17.5c0-.781-.593-1.42-1.355-1.493L6.5 16zm0-12C5.67 4 5 4.67 5 5.5S5.67 7 6.5 7 8 6.33 8 5.5c0-.781-.593-1.42-1.355-1.493L6.5 4zm3.5 8c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L20 12c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L10 12zm0 6c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L20 18c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L10 18zm0-12c0 .552.456 1 .995 1h8.01c.51 0 .93-.383.988-.883L20 6c0-.552-.456-1-.995-1h-8.01a.994.994 0 00-.988.883L10 6z",
        clipRule: "evenodd"
    })));
};
EditorBullet.displayName = 'EditorBullet';
export default EditorBullet;

//# sourceMappingURL=EditorBullet.js.map